import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useState } from 'react'
import { useDiRef } from '@/common/react/di-hooks'
import type { ObjectTypesService } from '@/object-types/services/ObjectTypesService'

export interface CreateCollectionPopoverDto {
  objectTypeId: number
}

export interface NewNodePopover_CreatingCollectionProps {
  onItemSelected: (dto: CreateCollectionPopoverDto) => void
}

export function NewNodePopover_CreatingCollection({
  onItemSelected,
}: NewNodePopover_CreatingCollectionProps) {
  const [typeId, setTypeId] = useState<number | undefined>(undefined)
  const typesService = useDiRef<ObjectTypesService>('ObjectTypesService')

  const handleCreate = () => {
    if (!typeId) return
    onItemSelected({ objectTypeId: typeId })
  }

  return (
    <Box sx={{ p: 2, minWidth: 260 }}>
      <Stack spacing={2}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          <Tooltip
            sx={{ mr: 0.5 }}
            title="Collections are dynamic and provide a way to view all objects of the selected type,
            filtered by chosen criteria"
          >
            <IconButton size="small">
              <InfoOutlinedIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
          <Typography variant="subtitle1">Select type for collection:</Typography>
        </Box>

        <FormControl fullWidth size="small">
          <InputLabel>Type</InputLabel>
          <Select value={typeId ?? ''} label="Type" onChange={(e) => setTypeId(e.target.value)}>
            {typesService.selectedSpaceTypes$.value!.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {t.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button variant="contained" disabled={!typeId} onClick={handleCreate}>
          Create
        </Button>
      </Stack>
    </Box>
  )
}
